import { attr, fk, Model } from 'redux-orm';

class AwscChatMessage extends Model {
  static modelName = 'AwscChatMessage';

  static fields = {
    id: attr(),
    message: attr(),
    messageType: attr(),
    direction: attr(),
    sentAt: attr(),
    scheduledAt: attr(),
    status: attr(),
    inboundPhoneNumber: attr(),
    outboundPhoneNumber: attr(),
    deletedAt: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    updatedBy: fk('Client', 'awscChatMessageChanger'),
    clientId: fk({
      to: 'Client',
      as: 'client',
      relatedName: 'clientAwscChatMessage',
    }),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'patientAwscChatMessage',
    }),
  };
}

export default AwscChatMessage;
